import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const PrimaryButton = ({
  children,
  onClick,
  type = "button",
  testId,
  className = "",
  withArrow = true,
}) => (
  <motion.button
    type={type}
    data-testid={testId}
    onClick={onClick}
    whileHover={{ scale: 1.03, rotate: -0.7 }}
    whileTap={{ scale: 0.97 }}
    transition={{ type: "spring", stiffness: 420, damping: 22 }}
    className={`group inline-flex items-center justify-center gap-2 bg-sunbeam text-ink font-display font-black lowercase tracking-tight rounded-full px-8 py-4 text-lg sm:text-xl leading-none shadow-[0_6px_0_0_#1C1B18] hover:shadow-[0_3px_0_0_#1C1B18] active:shadow-[0_2px_0_0_#1C1B18] transition-shadow ${className}`}
  >
    {children}
    {withArrow && (
      <ArrowUpRight
        className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
        strokeWidth={2.5}
      />
    )}
  </motion.button>
);
